import { render, staticRenderFns } from "./ProposalStatus.vue?vue&type=template&id=f87790a8"
import script from "./ProposalStatus.vue?vue&type=script&lang=js"
export * from "./ProposalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports